var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("H1", { staticClass: "pageTitle" }, [_vm._v("EMAIL UNVERIFIED")]),
        _vm._v(" "),
        _c("div", { staticClass: "limitWidth has-text-white" }, [
          _c("div", { staticClass: "is-size-4 top40" }, [
            _vm._v(
              "\n                Your Email has not been Verified!\n            "
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "top20" }, [
            _vm._v(
              "\n                Please check your email for a confirmation and instructions on how to verify your account.\n                After doing so, click the button below to login.\n            "
            )
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "top10" }, [
            _vm._v(
              "\n                If you have not received the email in your inbox please check your junk-email. You can also click\n                "
            ),
            _c(
              "a",
              {
                staticClass: "has-text-warning",
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.resend.apply(null, arguments)
                  }
                }
              },
              [_vm._v("here")]
            ),
            _vm._v(" to have it resent.\n            ")
          ]),
          _vm._v(" "),
          _c(
            "p",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showMsg,
                  expression: "showMsg"
                }
              ],
              staticClass: "has-text-weight-bold top10"
            },
            [
              _vm._v(
                "\n                A new confirmation email has been sent to your email address.\n            "
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "top20" }, [
            _c(
              "button",
              {
                staticClass: "button is-warning",
                on: {
                  click: function($event) {
                    return _vm.$root.showModalLogin({})
                  }
                }
              },
              [_vm._v("LOG IN")]
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b37a9cf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b37a9cf6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Unverified.vue
// module id = null
// module chunks = 